export default __webpack_public_path__ + "static/media/29-birthday-celebration.d417fd78.jpeg";